import { makeVar } from '@apollo/client';
export var reactiveCartData = makeVar({
  discountedPrice: undefined,
  totalWithCurrencyFormat: undefined
});
export var reactiveAltProductData = makeVar({
  altItemData: [],
  altPriceTotalWithTaxCurrency: '',
  altPrice: '',
  altPriceWithoutCurrency: undefined,
  altDiscountedPrice: undefined,
  isAltDiscountedPriceFetched: false
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/lib/ApolloSchema/reactiveVars.js
// module id = 486
// module chunks = 11